export default "__VITE_ASSET__FzoL5ljV__"